module.exports = __webpack_public_path__ + "assets/images/skincolor-02.61a2b922514df837e7dd70d0da81e896.svg";